"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: 'əvvəl',
  suffixFromNow: 'sonra',
  seconds: 'saniyələr',
  minute: '1 dəqiqə',
  minutes: '%d dəqiqə',
  hour: '1 saat',
  hours: '%d saat',
  day: '1 gün',
  days: '%d gün',
  month: '1 ay',
  months: '%d ay',
  year: '1 il',
  years: '%d il',
  wordSeparator: ''
};
var _default = strings;
exports["default"] = _default;